import React, { useEffect, useState } from 'react';

import RiskMatrix from '../Charts/Risk/RiskMatrix';
//import GeneralRisk from '../Charts/Risk/GeneralRisk';
import FinancialSankey from '../Charts/Risk/Sankey.js';
import RiskLine from '../Charts/General/RiskLineChart';
import Planner from '../Charts/Risk/WaterfallChart';
import AnimatedTabCard from '../Charts/Risk/AnimatedTabCard';


import { connect } from "react-redux";
import { compose } from "redux";

import { getRiskDashboardData } from "../../store/actions/dashboardActions";


const RiskDashboard = (props) => {

    const { match, getRiskDashboardDataFN, risk_dashboard_data } = props;

    const [chartTitle, setChartTitle] = useState("Operational Risk");

    const [tabIndex, setTabIndex] = useState(0);
    const tabs = ['Risk', 'Controls', 'Actions'];
    ////console.log("risk dashbaord data", risk_dashboard_data);

    useEffect(() => {
        ////console.log('Fetching risk dashboard data for ID:', match.params.id);
        getRiskDashboardDataFN(match.params.id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    ////console.log(risk_dashboard_data.data_for_responsive_cards_risks);

    return (

        <div className="flex flex-col p-4" style={{ minHeight: `calc(100vh - 245px)` }}>
            {/* First Row: Three Equal Columns */}
            <div className="flex flex-grow w-full">




            <div className="w-1/3 bg-white shadow-lg rounded-[5px]  m-4">
                <AnimatedTabCard
                    tabs={["Risk", "Controls", "Actions"]}
                    data={{
                    risks: risk_dashboard_data?.data_for_responsive_cards_risks || [],
                    controls: risk_dashboard_data?.data_for_responsive_cards_controls || [],
                    actions: risk_dashboard_data?.data_for_responsive_cards_actions || [],
                    }}
                    height={(window.innerHeight - 375) / 2}
                />
                </div>



                {/*<div className="w-1/3 bg-white shadow-lg rounded-[5px] border border-gray-150 ml-2 mr-2">


                    <div className="bg-[#3B3b3B] text-white px-4 py-2 flex-none flex items-center justify-center rounded-tl-[5px] rounded-tr-[5px]">

                        <div className="flex justify-center items-center gap-1 flex-nowrap overflow-hidden">

                            <h2 className="text-base sm:text-xs md:text-xs lg:text-base font-bold items-center text-ellipsis whitespace-nowrap m-0">
                                General Risk Level
                            </h2>

                        </div>


                    </div>

                    <div className="contents p-2">
                        <GeneralRisk height={(window.innerHeight - 290) / 2} data={risk_dashboard_data && risk_dashboard_data.general_risk} />
                    </div>


                </div>*/}


                <div className="w-1/3 bg-white shadow-lg rounded-[5px] border border-gray-150 m-4">
                    <div className="bg-[#3B3b3B] text-white px-4 py-2 flex-none flex items-center justify-center rounded-tl-[5px] rounded-tr-[5px]">
                        <div className="flex justify-center items-center gap-1 flex-nowrap overflow-hidden">
                            <h2 className="text-base sm:text-xs md:text-xs lg:text-base font-bold items-center text-ellipsis whitespace-nowrap m-0">
                                {chartTitle}
                            </h2>
                        </div>
                    </div>

                    <div className="contents p-2">
                        <RiskMatrix height={(window.innerHeight - 350) / 2} data={risk_dashboard_data && risk_dashboard_data.risk_matrix} setChartTitle={setChartTitle} />
                    </div>
                </div>


                <div className="w-1/3 bg-white shadow-lg rounded-[5px] border border-gray-150 m-4">


                    <div className="bg-[#3B3b3B] text-white px-4 py-2 flex-none flex items-center justify-center rounded-tl-[5px] rounded-tr-[5px]">
                        <div className="flex justify-center items-center gap-1 flex-nowrap overflow-hidden">
                            <h2 className="text-base sm:text-xs md:text-xs lg:text-base font-bold items-center text-ellipsis whitespace-nowrap m-0">
                                Financial Risk
                            </h2>
                        </div>
                    </div>


                    <div className="contents p-2">
                        <FinancialSankey height={(window.innerHeight - 375) / 2} data={risk_dashboard_data && risk_dashboard_data.financial_risk} />

                    </div>



                </div>
            </div>

            {/* Second Row: Two Columns (2/3 and 1/3) */}
            <div className="flex flex-grow w-full mt-4">
                <div className="w-full bg-white shadow-lg rounded-[5px] border border-gray-150 m-4">
                    <div className="bg-[#3B3b3B] text-white p-2 flex-none flex items-center justify-between rounded-tl-[5px] rounded-tr-[5px]">

                        <div className="w-full flex justify-between">
                            <div className="flex flex-col items-center w-1/2">
                                <h2 className="text-base sm:text-xs md:text-xs lg:text-base font-bold text-ellipsis whitespace-nowrap m-0 mb-2">
                                    General Risk Level Time Series
                                </h2>
                            </div>

                            <div className="flex flex-col items-center w-1/2">
                                <h2 className="text-base sm:text-xs md:text-xs lg:text-base font-bold text-ellipsis whitespace-nowrap m-0 mb-2">
                                    Action Timeline
                                </h2>
                            </div>
                        </div>

                    </div>

                    <div className="contents p-2">
                        <div className="flex">
                            <div className="w-1/2">
                                <RiskLine height={(window.innerHeight - 375) / 2} data={risk_dashboard_data && risk_dashboard_data.risk_line} />
                            </div>
                            <div className="w-1/2">
                                <Planner height={(window.innerHeight - 375) / 2} data={risk_dashboard_data && risk_dashboard_data.max_5_actions} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>



    );
};


const mapStateToProps = (state) => {
    return {

        risk_dashboard_data: state.dashboard.risk_dashboard_data,


    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getRiskDashboardDataFN: (risk_id) => dispatch(getRiskDashboardData(risk_id)),

    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(RiskDashboard);
